import styled from 'styled-components';
import { Property } from 'csstype';

import {
  BackgroundStyling,
  BackgroundStylingProps,
  BorderStyling,
  BorderStylingProps,
  DimensionStyling,
  DimensionStylingProps,
  MarginStyling,
  MarginStylingProps,
  OverflowStyling,
  OverflowStylingProps,
  PaddingStyling,
  PaddingStylingProps,
} from '../../styling';

export interface FlexContainerProps {
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  alignSelf?: 'stretch' | 'center' | 'start' | 'end';
  gap?: string;
  dimensions?: DimensionStylingProps;
  padding?: PaddingStylingProps;
  margin?: MarginStylingProps;
  overflow?: OverflowStylingProps;
  border?: BorderStylingProps;
  background?: BackgroundStylingProps;
  position?: Property.Position;
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection ?? 'unset'};
  align-self: ${({ alignSelf }) => alignSelf ?? 'unset'};
  flex-wrap: ${({ flexWrap }) => flexWrap ?? 'unset'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'unset'};
  align-items: ${({ alignItems }) => alignItems ?? 'unset'};
  align-content: ${({ alignContent }) => alignContent ?? 'unset'};
  gap: ${({ gap }) => gap ?? 'unset'};

  box-sizing: border-box;
  ${({ dimensions }) => (dimensions ? DimensionStyling(dimensions) : '')};
  ${({ padding }) => (padding ? PaddingStyling(padding) : '')};
  ${({ margin }) => (margin ? MarginStyling(margin) : '')};
  ${({ overflow }) => (overflow ? OverflowStyling(overflow) : '')};
  ${({ border }) => BorderStyling({ ...border })};
  ${({ background }) => BackgroundStyling({ ...background })};

  position: ${({ position }) => position};
`;
